import { useCallback, useEffect, useState } from 'react';

/**
 * Small async data hook used across content pages.
 * It simulates an async fetch (so loading / error / empty states are real),
 * and supports retry via reload().
 */
export function useAsyncData<T>(runner: () => T, deps: unknown[]) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [nonce, setNonce] = useState(0);

  const reload = useCallback(() => setNonce((n) => n + 1), []);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    const timer = window.setTimeout(() => {
      try {
        const result = runner();
        if (active) {
          setData(result);
          setLoading(false);
        }
      } catch {
        if (active) {
          setError('网络异常，数据加载失败，请点击重试');
          setLoading(false);
        }
      }
    }, 350);
    return () => {
      active = false;
      window.clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, nonce]);

  return { data, loading, error, reload };
}